<div class="basemapGallery" style="z-index: 101;" [hidden]="(isVisible$ | async) === false">
    <div ngbDropdown placement="bottom-right" class="btn-group btn-group-sm" role="group"
        [attr.data-cy]="'basemap-gallery'" #galleryDropdown="ngbDropdown">
        <button ngbDropdownToggle type="button" class="btn rounded galleryButton pt-0 pb-0" style="font-size: 1rem"
            aria-haspopup="true">
            <i class="glyphicon icon-th-large x-large p-0" style="line-height: inherit;"></i>
        </button>
        <div ngbDropdownMenu class="p-0 galleryDropdown bg-light rounded">
            <div *ngFor="let layer of hsLayerManagerService.data.baselayers" [attr.data-cy]="layer.title"
                (click)="toggleBasemap(layer);" [ngStyle]="{'position':'relative'}" class="m-0 ">
                <div style="position:absolute;top:5px; right:5px;z-index:5"
                    [ngClass]="layer.galleryMiniMenu ? 'text-white' : 'text-primary'" *ngIf="layer.active"
                    (click)="$event.preventDefault();toggleMiniMenu(layer)">
                    <span class="glyphicon icon-menu icon-small"></span>
                </div>
                <div class="hs-miniMenu" [hidden]="!(layer.galleryMiniMenu === true && layer.active)"
                    [ngStyle]="{'position':'absolute'}" [ngClass]="{'expanded': hsLayerManagerService.menuExpanded}">
                    <!-- TODO: Remove function call from template -->
                    <div class="ps-1 w-100" *ngIf="!hsLayerManagerService.menuExpanded"
                        (click)="hsLayerManagerService.setGreyscale(layer)">
                        <label class="form-check-label m-0"
                            [ngClass]="getGreyscale(layer.layer) ? 'hs-checkmark' : 'hs-uncheckmark'"></label>
                        <p class="ms-1 mb-0">
                            {{'LAYERMANAGER.baseMapGallery.greyscale' | translateHs }}</p>
                    </div>
                    <label [attr.id]="layer?.idString()" class="ps-2 mb-0 w-100"
                        [ngStyle]="{'background-color':'rgba(192, 189, 189, 0.644)'}" (click)="expandMenu(layer)">
                        <ng-container *ngIf="hsLayerManagerService.menuExpanded;else more">
                            {{'COMMON.less' | translateHs }}
                        </ng-container>
                        <ng-template #more>
                            {{'COMMON.more' | translateHs }}
                        </ng-template>
                    </label>
                </div>

                <img [ngClass]="{'active': layer.active}" [src]="layer.thumbnail"
                    [alt]="'LAYERMANAGER.basemapThumbnail' | translateHs " style="width:100%">
                <a class="dropdown-item flex-grow-1 d-flex align-items-center text-truncate"
                    [ngClass]="{'active': layer.active}">{{layer.title | translateHs : {module: 'LAYERS'}
                    }}</a>
            </div>
            <div (click)="toggleBasemap()">
                <div style="height: 4.5em; width: 100%; background: white"
                    [ngClass]="{'active': !hsLayerManagerService.data.baselayersVisible}"></div>
                <a class="dropdown-item flex-grow-1 d-flex align-items-center text-truncate"
                    [ngClass]="{'active': !hsLayerManagerService.data.baselayersVisible}">{{'LAYERMANAGER.baseMapGallery.noBaseMap'
                    | translateHs }}</a>
            </div>
        </div>
    </div>
</div>